module.exports = __webpack_public_path__ + "static/media/ic-enfermagem.6ffddbe0.svg";